export enum ActivityMethod {
  Interaction = 'Interaction',
  Electronic = 'Electronic'
}
